module.exports = __webpack_public_path__ + "static/media/fire-loop.cc1b405f.mov";